import React, { ChangeEvent, useCallback, useEffect, useState, useRef } from 'react'

interface Props {
  min: number;
  max: number;
  filteredMin: number;
  filteredMax: number;
  formatNumber: Function;
  onChangeMin: Function;
  onChangeMax: Function;
}

const MultiRangeSlider = (props: Props) => {
  const {
    min,
    max,
    filteredMin,
    filteredMax,
    formatNumber,
    onChangeMin,
    onChangeMax
  } = props

  const BASE_CLASS_CSS = 'filter-price'

  const [minVal, setMinVal] = useState(min)
  const [maxVal, setMaxVal] = useState(max)
  const minValRef = useRef(min)
  const maxValRef = useRef(max)
  const range = useRef<HTMLDivElement>(null)

  const getPercent = useCallback(
    (value: number) => Math.round(((value - min) / (max - min)) * 100),
    [min, max]
  )

  useEffect(() => {
    const minPercent = getPercent(minVal)
    const maxPercent = getPercent(maxValRef.current)

    if (range.current) {
      range.current.style.left = `${minPercent}%`
      range.current.style.width = `${maxPercent - minPercent}%`
    }
  }, [minVal, getPercent])

  useEffect(() => {
    const minPercent = getPercent(minValRef.current)
    const maxPercent = getPercent(maxVal)

    if (range.current) {
      range.current.style.width = `${maxPercent - minPercent}%`
    }
  }, [maxVal, getPercent])

  useEffect(() => {
    if (filteredMin) {
      const valueMin = Math.min(Number(filteredMin), maxVal - 1)
      setMinVal(valueMin)
      minValRef.current = valueMin
    }

    if (filteredMax) {
      const valueMax = Math.max(Number(filteredMax), minVal + 1)
      setMaxVal(valueMax)
      maxValRef.current = valueMax
    }
  }, [])

  return (
    <React.Fragment>
      <div className={`${BASE_CLASS_CSS}-slider-container`}>
        <div className={`${BASE_CLASS_CSS}-slider-wrapper`}>
          <input
            type="range"
            min={min}
            max={max}
            value={minVal}
            onChange={(event: ChangeEvent<HTMLInputElement>) => {
              const value = Math.min(Number(event.target.value), maxVal - 1)
              setMinVal(value)
              minValRef.current = value
              onChangeMin(value)
            }}
            className={`${BASE_CLASS_CSS}-slider-input`}
            style={{
              zIndex: minVal > max - 100 ? 5 : 3
            }}
          />
          <input
            type="range"
            min={min}
            max={max}
            value={maxVal}
            onChange={(event: ChangeEvent<HTMLInputElement>) => {
              const value = Math.max(Number(event.target.value), minVal + 1)
              setMaxVal(value)
              maxValRef.current = value
              onChangeMax(value)
            }}
            className={`${BASE_CLASS_CSS}-slider-input`}
            style={{
              zIndex: 4
            }}
          />

          <div className={`${BASE_CLASS_CSS}-slider-inner`}>
            <div className="back-slider"></div>
            <div ref={range} className="front-slider"></div>
            <div className="lowest-price">{formatNumber(minVal)}</div>
            <div className="biggest-price">{formatNumber(maxVal)}</div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default MultiRangeSlider
